import { render, staticRenderFns } from "./newprojectsdashboard.vue?vue&type=template&id=22dfafc2"
import script from "./newprojectsdashboard.vue?vue&type=script&lang=ts"
export * from "./newprojectsdashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22dfafc2')) {
      api.createRecord('22dfafc2', component.options)
    } else {
      api.reload('22dfafc2', component.options)
    }
    module.hot.accept("./newprojectsdashboard.vue?vue&type=template&id=22dfafc2", function () {
      api.rerender('22dfafc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyProjects/newprojectsdashboard.vue"
export default component.exports